//todo move to inside of menu container components
export { default } from "./MenuCard";
